/**
 * API helper for handling errors consistently
 */
const handleApiError = (error, operation) => {
  // Only log in development
  if (process.env.NODE_ENV === "development") {
    console.error(`Forms API ${operation} error:`, error);
  }
  return { error: error?.message || `Failed to ${operation}` };
};

export const editForm = async (props) => {
  const {
    apiUrl,
    formId,
    payload,
    token,
  } = props;

  try {
    const response = await fetch(`${apiUrl}forms/${formId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "auth-token": token,
      },
      body: JSON.stringify(payload)
    });
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    
    return await response.json();
  } catch (err) {
    return handleApiError(err, "edit form");
  }
};

export const deleteForm = async (props) => {
  const {
    apiUrl,
    formId,
    token,
  } = props;

  try {
    const response = await fetch(`${apiUrl}forms/${formId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "auth-token": token,
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    
    return await response.json();
  } catch (err) {
    return handleApiError(err, "delete form");
  }
};

export const getForms = async (props) => {
  const {
    apiUrl,
    token,
  } = props;

  try {
    const response = await fetch(`${apiUrl}forms/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "auth-token": token,
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    
    return await response.json();
  } catch (err) {
    return handleApiError(err, "get forms");
  }
};

export const getForm = async (props) => {
  const {
    apiUrl,
    formId,
    token,
  } = props;

  try {
    const response = await fetch(`${apiUrl}forms/${formId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "auth-token": token,
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    
    return await response.json();
  } catch (err) {
    return handleApiError(err, "get form");
  }
};

